// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"MainContent_MainContent__jgnmy"};